import { render } from "./SearchResults.vue?vue&type=template&id=f577812e&ts=true"
import script from "./SearchResults.vue?vue&type=script&lang=ts"
export * from "./SearchResults.vue?vue&type=script&lang=ts"

import "./SearchResults.vue?vue&type=style&index=0&id=f577812e&lang=css"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__